import React from 'react';
import { useLanguage } from "../../../i18n";
import { useTranslation } from 'react-i18next';
import { useDefaultLogo } from "../../../hooks";
import { getServiceUrl } from "../../Layout/Header/Services/getLinkData";
import { Link } from "./..";
import { Text } from "../../Typography";
import styles from './Copyright.scss';

var Copyright = function Copyright() {
  var _useTranslation = useTranslation(['footerUi']),
      t = _useTranslation.t;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var defaultLogo = useDefaultLogo();
  return /*#__PURE__*/React.createElement(Link, {
    to: getServiceUrl('network', currentLang),
    className: styles.Copyright,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    className: styles.Copyright__text
  }, t('COPYRIGHT')), /*#__PURE__*/React.createElement("img", {
    src: defaultLogo,
    className: styles.Copyright__image,
    alt: "XYZ"
  }));
};

export default Copyright;